var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterDescending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 3.75C7.75 3.33579 7.41421 3 7 3C6.58579 3 6.25 3.33579 6.25 3.75V18.4393L4.53033 16.7197C4.23744 16.4268 3.76256 16.4268 3.46967 16.7197C3.17678 17.0126 3.17678 17.4874 3.46967 17.7803L6.46967 20.7803C6.76256 21.0732 7.23744 21.0732 7.53033 20.7803L10.5303 17.7803C10.8232 17.4874 10.8232 17.0126 10.5303 16.7197C10.2374 16.4268 9.76256 16.4268 9.46967 16.7197L7.75 18.4393V3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3C14.3358 3 14 3.33579 14 3.75C14 4.16421 14.3358 4.5 14.75 4.5H18.6329L14.1775 9.76554C13.9888 9.98848 13.9467 10.3006 14.0696 10.5656C14.1925 10.8305 14.458 11 14.75 11H20.25C20.6642 11 21 10.6642 21 10.25C21 9.83579 20.6642 9.5 20.25 9.5H16.3671L20.8225 4.23446C21.0112 4.01152 21.0533 3.69936 20.9304 3.43444C20.8075 3.16951 20.542 3 20.25 3H14.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1753 13.4236C18.0501 13.1648 17.788 13.0002 17.5005 13C17.213 12.9998 16.9506 13.164 16.8252 13.4227L13.6729 19.9227C13.4921 20.2954 13.6477 20.7441 14.0204 20.9248C14.3931 21.1056 14.8418 20.95 15.0225 20.5773L16.0299 18.5H18.9628L19.9663 20.5764C20.1466 20.9493 20.595 21.1055 20.968 20.9253C21.3409 20.745 21.4971 20.2966 21.3169 19.9236L18.1753 13.4236ZM17.4988 15.4711L18.2378 17H16.7574L17.4988 15.4711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDescending);
export default __webpack_public_path__ + "static/media/filter-descending.ff68a1d4ec4985af287d2523755fe325.svg";
export { ForwardRef as ReactComponent };